import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "odq-session-timeout-dialog",
    templateUrl: "./session-timeout-dialog.component.html",
    styleUrls: ["./session-timeout-dialog.component.scss"],
    standalone: false
})
export class SessionTimeoutDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutDialogComponent>,
    public translate: TranslateService
  ) {}

  onCloseDialog(): void {
    this.dialogRef.close(false);
  }
}
